<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="M9.4 10.6H5.2a.6.6 0 1 1 0-1.2h4.2V5.2a.6.6 0 0 1 1.2 0v4.2h4.2a.6.6 0 1 1 0 1.2h-4.2v4.2a.6.6 0 1 1-1.2 0v-4.2Z"
      />
    </svg>
  </span>
</template>
